import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import ReactDOM from 'react-dom';
import ws from './../utils/ws';
import { Link as RouterLink } from "react-router-dom";
import { PATH_DASHBOARD } from "../routes/paths";

const socket = ws.getSocket();

export default function Notifier() {
  const [popup, setPopup] = useState(false);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [taskId, setTaskId] = useState('');
  const [popupLinkActive, setPopupLinkActive] = useState(false);

  let popupTaskId: string = '';

  const handleClosePopup = () => {
    setPopup(false);
    popupTaskId = '';
  };

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    let strategies = {} as { [key: string]: (msg: object) => void };

    async function watch() {
      const s = await socket;

      s!.on("notification", (msg) => {
        console.log(msg);
        if (strategies[msg.type as keyof typeof strategies]) {
          strategies[msg.type as keyof typeof strategies](msg);
        }
      });
    }

    watch();

    strategies.cases_uploaded = (msg: any) => {
      enqueueSnackbar(`Cases ${msg.count} uploaded`);
    };

    strategies.finish_task = (msg: any) => {
      enqueueSnackbar(`Task ${msg.task_id} for ${msg.case_ids} is finished`);

      if (msg.task_id === popupTaskId) {
        setPopupLinkActive(true);
        setTaskId(msg.task_id);
      }
    };

    strategies.start_task = (msg: any) => {
      enqueueSnackbar(`Task ${msg.task_id} for ${msg.case_ids} is started`);
    };

    strategies.task_waiting_approval = (_msg: any) => {
      enqueueSnackbar('Results are waiting for approval', { variant: 'info' });
    };

    strategies.automation_started = (msg: any) => {
      popupTaskId = msg.task_id;
      ReactDOM.unstable_batchedUpdates(() => {
        setPopup(true);
        setPopupLinkActive(false);
        setTitle(`Automation is coming for ${msg.product.toUpperCase()}`);
        setContent('The MediOMX automation module has started new processing.');
      });
    };
  }, []);

  return (
    <Dialog fullWidth maxWidth="xs" open={popup} onClose={handleClosePopup}>
      <DialogTitle sx={{ pb: 2 }}>{title}</DialogTitle>

      {content && <DialogContent sx={{ typography: 'body2' }}> {content} </DialogContent>}

      <DialogActions>
        <Stack alignItems="flex-start" sx={{ mt: 3 }} direction="row" spacing={2}>
          <Button disabled={!popupLinkActive} variant="contained"
                  color="warning" onClick={handleClosePopup} component={RouterLink}
                  to={PATH_DASHBOARD.cases.resultsViewer(taskId)}>
            Go to result page
          </Button>
          <Button variant="outlined" color="inherit" onClick={handleClosePopup}>
            OK
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}

